import { Markup } from 'interweave';
import * as styleSheet from '../styles';
import { Box, Button, Image, Text } from '@enaep-ng/benchmark';
import { ErrorPropsV2 } from '../types';

export default function Error(props: ErrorPropsV2) {
  const renderButtons = () => {
    return (
      <Box>
        {props.buttons.map((buttonElem) => {
            const buttonStyle = {
                width: "calc(250px * var(--zoom))",
                height: "calc(57px * var(--zoom))",
                padding: "calc(10px * var(--zoom))",
                borderRadius: "calc(8px * var(--zoom))",
                boxSizing: "border-box",
                textAlign: "center",
                lineHeight: "normal",
                fontSize: "calc(20px * var(--zoom))",
                display: "inline-block",
                borderWidth: "calc(1px * var(--zoom))",
                borderStyle:"solid"

            }
            const variantStyle = buttonElem.variant === "primary" ? 
            {backgroundColor: "#fffefe",borderColor: "#797979",color: "#5e5e5e",marginRight:"0.5em"}
            :
            buttonElem.variant === "secondary" ?  {backgroundColor: "#696969",borderColor: "#696969",color: "#ffffff"} :
            {color: "#1159a7",background: "transparent",border: "none",padding: "calc(6px* var(--zoom)) calc(12px* var(--zoom))",textDecoration: "underline"}
            return (
            <>
                {buttonElem.variant === "link" ? <><br/></> : <></>}
                <Button
                    variant="bare"
                    onClick={buttonElem.action}
                    style={{
                        ...buttonStyle,
                        ...variantStyle
                    }}
                    >
                        <Markup  attributes={{ key: buttonElem.key || '1' }} content={buttonElem.label} /> 
                </Button>
            </>)
            })
        }
      </Box>
    );
  };
  return (
    <Box style={{marginLeft: "4em"}}>
        <Box style={{display: "flex",marginBottom: "2em"}}>
            <Image width="2em" src={props.iconSrc} style={{
                height: "2em !important",
                marginRight: ".5em",}} />
            <Text style={{fontWeight: "600",color: "#900202",fontSize: "calc(30px * var(--zoom))"}}>{props.title}</Text>
        </Box>
        <Box style={{textAlign: "left",marginBottom: "1em"}}>
            {
                props.content.map((message:string)=>{
                    return(
                        <div>
                            <Markup className="router-error-content" content={message} />
                        </div>
                    )
                })  
            }
        </Box>
        {props.errorCode ? 
        <Box style={{color:"#900202",fontWeight:700,marginBottom: "2em",display:"flex"}}>
            {props.errorCode}
        </Box> :
        <Box style={{marginBottom: "2em"}}>
        </Box>}
        <Box sx={{display: 'flex'}}>
            {renderButtons()}
        </Box>
    </Box>
  );
}
